<div [class.closed]="isClosed()" [class.open]="isOpen()" class="item">
  <div (click)="toggleOpen()" class="title d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      @if (icon()) {
        <lucide-icon [img]="icon()" class="me-1"></lucide-icon>
      }
      {{ title() }}
    </div>
    <div class="toggle-container" style="color: currentColor;">
      <lucide-icon [img]="chevron()"></lucide-icon>
    </div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
